/**
 * Light/dark toggle for the landing page.
 *
 * Shares the `emx-theme` storage key with the application, so a preference set
 * on the landing page carries into the product and back. The value is applied
 * before first paint by the inline snippet in index.html's <head> — the landing
 * bundle is deferred, so this file only owns the button, not the initial paint.
 */

const STORAGE_KEY = "emx-theme";
const LIGHT = "light";
const DARK = "dark";

function currentTheme() {
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved === LIGHT || saved === DARK) return saved;
  } catch (e) {
    // Safari in private mode throws on access rather than returning null.
  }
  return DARK;
}

function applyTheme(theme) {
  const next = theme === LIGHT ? LIGHT : DARK;
  document.documentElement.setAttribute("data-theme", next);
  try {
    window.localStorage.setItem(STORAGE_KEY, next);
  } catch (e) {
    // Not fatal — the theme still applies for this page view.
  }

  const button = document.getElementById("ldThemeToggle");
  if (button) button.setAttribute("aria-pressed", String(next === LIGHT));
}

function initLandingTheme() {
  const button = document.getElementById("ldThemeToggle");
  if (!button) return;

  // Reflect the theme the inline snippet already applied.
  applyTheme(currentTheme());

  button.addEventListener("click", () => {
    applyTheme(currentTheme() === LIGHT ? DARK : LIGHT);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initLandingTheme);
} else {
  initLandingTheme();
}
